import { render, staticRenderFns } from "./basicMaintainer.vue?vue&type=template&id=2b5381ec&scoped=true"
import script from "./basicMaintainer.vue?vue&type=script&lang=js"
export * from "./basicMaintainer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5381ec",
  null
  
)

export default component.exports